enum iCoreTicketType {
    betinvent = 'betinvent',
    liveoffline = 'liveoffline',
    live = 'live',
}

export enum TicketTypeParam {
    sevenretail = 'sevenretail',
    liveoffline = 'liveoffline',
    live = 'live',
}

export enum TicketTypeEndpoint {
    cache,
    iCore,
}

// rewritten from php code
function assertTicketType(ticketId: string) {
    let type: iCoreTicketType | TicketTypeParam;

    if (ticketId.indexOf('-') !== -1) {
        type = iCoreTicketType.betinvent;
    } else if (ticketId.length === 13) {
        type = iCoreTicketType.liveoffline;
    } else if (
        ticketId.length === 10 && ticketId[0].toUpperCase() === 'R'
        || ticketId.length === 9 && ticketId.substr(0, 2).toUpperCase() === 'X1'
    ) {
        type = TicketTypeParam.sevenretail;
    } else {
        type = iCoreTicketType.live;
    }
    return type;
}

export function processTicketId(ticketId: string, ticketType: TicketTypeParam) {
    if (ticketType === TicketTypeParam.sevenretail && ticketId[0].toUpperCase() === 'R') {
        return ticketId.substr(1);
    }
    return ticketId;
}

export function getTicketType(ticketId: string) {
    const ticketType = assertTicketType(ticketId);
    if (ticketType in TicketTypeParam) {
        return {
            ticketType: ticketType as TicketTypeParam,
            ticketTypeEndpoint: TicketTypeEndpoint.iCore,
        };
    }
    return {
        ticketTypeEndpoint: TicketTypeEndpoint.cache,
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/tickets/_private/helpers.ts